import * as React from "react";
import { Menu, Drawer, Divider } from "antd";
import Link from "../../components/app/Link";
import { TTranslate } from "../../../service/locale/TranslationService";
import { IMenuItem } from "../../../model/menu/MenuItem";
import { ILanguage } from "../../../model/language/Language";

const PortalMobileMenu = ({
  translate,
  menuItems,
  onSelectMenuItem,
  selectedLanguage,
  changeLanguage,
  languages,
  visible,
  onClose
}: {
  translate: TTranslate;
  menuItems: IMenuItem[];
  onSelectMenuItem(menuItem: IMenuItem): void;
  selectedLanguage: ILanguage;
  changeLanguage: (language: ILanguage) => Promise<void>;
  languages: ILanguage[];
  visible: boolean;
  onClose: () => void;
}) => {
  const redirect = (path: string) => {
    window.location.href = path;
  };

  const renderMenuItem = (menuItem: IMenuItem) => {
    return menuItem.children.length ? (
      <Menu.SubMenu key={menuItem.id} title={<span>{menuItem.name}</span>}>
        {menuItem.children
          .sort((a, b) => a.rbr - b.rbr)
          .map((child) => renderMenuItem(child))}
      </Menu.SubMenu>
    ) : (
      <Menu.Item
        key={menuItem.id}
        style={{ whiteSpace: "normal", height: "auto", fontSize: "1em" }}
      >
        <Link onClick={() => onSelectMenuItem(menuItem)}>{menuItem.name}</Link>
      </Menu.Item>
    );
  };

  const renderLanguageSubmenuItems = (languages: ILanguage[]) => {
    let languageItems: JSX.Element[] = [];

    languages?.forEach((language: ILanguage) => {
      languageItems.push(
        <Menu.Item onClick={() => changeLanguage(language)} key={language.code}>
          {language.name}
        </Menu.Item>
      );
    });
    return languageItems;
  };

  return (
    <Drawer
      className={"mobile-portal-menu"}
      closable={false}
      maskClosable={true}
      placement={"right"}
      visible={visible}
      onClose={() => onClose()}
      width={"100%"}
    >
      <Menu mode="inline">
        <Menu.Item key={"0"}>
          <Link onClick={() => redirect("/home")}>
            {translate("portal_office_layout.home")}
          </Link>
        </Menu.Item>
        {(menuItems || []).map(
          (menuItem) => menuItem.valid && renderMenuItem(menuItem)
        )}
        <Divider orientation={"center"}>
          {translate("portal_office_layout.language")}
        </Divider>
        <Menu.SubMenu title={selectedLanguage?.name}>
          {renderLanguageSubmenuItems(languages)}
        </Menu.SubMenu>
      </Menu>
    </Drawer>
  );
};

export default PortalMobileMenu;
